import axios from 'axios'
import store from './store/index'

const DEBUG = process.env.NODE_ENV === 'development' && true
const PRODUCTION = location.origin === 'https://toro.heseya.com'

const API_URLS = {
  production: 'https://toro-api.heseya.com',
  canary: 'https://canary.api.toro.heseya.com',
  local: 'http://toro.test'
}

const baseURL = PRODUCTION ? API_URLS.production : DEBUG ? API_URLS.local : API_URLS.canary

export const api = axios.create({
  baseURL,
  contentType: 'json',
  withCredentials: true,
  headers: {'Requested-With': 'XMLHttpRequest'}
})

api.interceptors.request.use(config => {

  const token = store.getters['user/getToken']
  const refreshToken = store.state.user.session.refresh_token

  if (token !== null) {
    config.headers.Authorization = `Bearer ${token}`
    config.headers['Refresh-Token'] = `Bearer ${refreshToken}`
  }

  const activeOrganization = store.state.user.activeOrganization

  if (activeOrganization !== null) {
    config.headers['Active-Organization'] = activeOrganization + ''
  }

  return config
})

api.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch('user/logout')
  }

  console.error('API request error', error.response)

  return Promise.reject(error)
})
